// @ts-nocheck
/* eslint-disable */
import { call, put, takeLatest } from 'redux-saga/effects';
import { HIDE_FULLSCREEN_LOADER, SHOW_FULLSCREEN_LOADER } from 'appRedux/actions/loader';
import { UPDATE_TAB_EDITED_STATE } from 'appRedux/actions/project_budget';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import { successToast } from 'utils/toastHandler';
import getQueryParams from 'utils/getQueryParams';
import {
  ADD_NEW_DAILY_COST_REQUEST,
  ADD_NEW_DAILY_COST_SUCCESS,
  DELETE_ATTACHED_DOCUMENT,
  DELETE_ATTACHED_DOCUMENT_SUCCESS,
  DELETE_COST_TRACKING_NOTE_REQUEST,
  DELETE_COST_TRACKING_NOTE_SUCCESS,
  DELETE_DAILY_COST_REQUEST,
  DELETE_DAILY_COST_SUCCESS,
  GET_COST_TRACKING_DATA_REQUEST,
  GET_COST_TRACKING_DATA_SUCCESS,
  GET_COST_TRACKING_HR_DATA_REQUEST,
  GET_COST_TRACKING_HR_DATA_SUCCESS,
  GET_COST_TRACKING_ROW_DATA_REQUEST,
  GET_COST_TRACKING_ROW_DATA_SUCCESS,
  GET_DAILY_COST_RESOURCE_LIST_REQUEST,
  GET_DAILY_COST_RESOURCE_LIST_SUCCESS,
  GET_DAILY_COST_SUBTASK_LIST_REQUEST,
  GET_DAILY_COST_SUBTASK_LIST_SUCCESS,
  POST_COST_TRACKING_DOCUMENT,
  POST_COST_TRACKING_DOCUMENT_SUCCESS,
  POST_COST_TRACKING_NOTE_REQUEST,
  POST_COST_TRACKING_NOTE_SUCCESS,
  UPDATE_COST_TRACKING_NOTE_REQUEST,
  UPDATE_COST_TRACKING_NOTE_SUCCESS,
} from '../constants/cost_tracking';

function* getCostTrackingDataRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/daily_cost_tracking/?${query}`,
    token,
  );

  if (data) {
    yield put({ type: GET_COST_TRACKING_DATA_SUCCESS, payload: data });
  }
}

function* getCostTrackingHrDataRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/daily_cost_tracking_horizontal/?${query}`,
    token,
  );

  if (data) {
    yield put({ type: GET_COST_TRACKING_HR_DATA_SUCCESS, payload: data });
  }
}

function* addDailyCostRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/daily_cost_tracking_post/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: UPDATE_TAB_EDITED_STATE, payload: { tabEdited: false } });
    yield put({
      type: ADD_NEW_DAILY_COST_SUCCESS,
    });
    successToast('Data was updated successfully.');
  }
}

function* getCostTrackingRowDataRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/daily_cost_tracking/${payload.id}/`,
    token,
  );

  if (data) {
    yield put({
      type: GET_COST_TRACKING_ROW_DATA_SUCCESS,
      payload: data,
      reqPayload: payload,
    });
  }
}

function* postCostTrackingDocument(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.postFormData,
    `${API_URI}/cost_tracking_files/`,
    'post',
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: POST_COST_TRACKING_DOCUMENT_SUCCESS,
      payload: { ...data, dailyCostId: payload.daily_cost },
      // requestPayload: payload
    });
    successToast('File was added successfully.');
  }
}

function* deleteAttachedDocument(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/cost_tracking_files/${payload.id}`,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: DELETE_ATTACHED_DOCUMENT_SUCCESS,
      payload: { deletedId: payload.id, attachementId: payload.attachementId },
    });
    successToast('File was deleted successfully.');
  }
}
function* postCostTrackingNoteRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/cost_tracking_note/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: POST_COST_TRACKING_NOTE_SUCCESS,
      payload: { ...data, dailyCostId: payload.dailyCostId },
      // requestPayload: payload
    });
    successToast('Note was added successfully.');
  }
}

function* updateCostTrackingNoteRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPutApi,
    `${API_URI}/cost_tracking_note/${payload.id}/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: UPDATE_COST_TRACKING_NOTE_SUCCESS,
      payload: { ...data, dailyCostId: payload.dailyCostId },
    });
    successToast('Note was updated successfully.');
  }
}

function* deleteCostTrackingNoteRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/cost_tracking_note/${payload.noteId}/`,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: DELETE_COST_TRACKING_NOTE_SUCCESS,
      payload,
    });
    successToast('Note was deleted successfully.');
  }
}

function* getDailyCostSubTaskListRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchGetApi,

    `${API_URI}/sub-task/?task_id=${payload.taskId}`,

    token,
  );

  if (data) {
    yield put({
      type: GET_DAILY_COST_SUBTASK_LIST_SUCCESS,
      payload: data,
      reqPayload: payload,
    });
  }
}

function* getDailyCostResourceListRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);
  const data = yield call(
    services.fetchGetApi,

    `${API_URI}/resource_rate/?${query}`,

    token,
  );

  if (data) {
    yield put({
      type: GET_DAILY_COST_RESOURCE_LIST_SUCCESS,
      payload: data,
      reqPayload: payload,
    });
  }
}

function* deleteDailyCostRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/feature_delete/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: DELETE_DAILY_COST_SUCCESS,
    });
    successToast('Data was deleted successfully.');
  }
}

function* costTrackingWatcher() {
  yield takeLatest(
    GET_COST_TRACKING_DATA_REQUEST,
    getCostTrackingDataRequest,
  );

  yield takeLatest(
    GET_COST_TRACKING_HR_DATA_REQUEST,
    getCostTrackingHrDataRequest,
  );

  yield takeLatest(
    GET_COST_TRACKING_ROW_DATA_REQUEST,
    getCostTrackingRowDataRequest,
  );

  yield takeLatest(
    POST_COST_TRACKING_NOTE_REQUEST,
    postCostTrackingNoteRequest,
  );

  yield takeLatest(POST_COST_TRACKING_DOCUMENT, postCostTrackingDocument);

  yield takeLatest(DELETE_ATTACHED_DOCUMENT, deleteAttachedDocument);

  yield takeLatest(
    DELETE_COST_TRACKING_NOTE_REQUEST,
    deleteCostTrackingNoteRequest,
  );

  yield takeLatest(
    UPDATE_COST_TRACKING_NOTE_REQUEST,
    updateCostTrackingNoteRequest,
  );

  yield takeLatest(ADD_NEW_DAILY_COST_REQUEST, addDailyCostRequest);

  yield takeLatest(
    GET_DAILY_COST_SUBTASK_LIST_REQUEST,
    getDailyCostSubTaskListRequest,
  );

  yield takeLatest(
    GET_DAILY_COST_RESOURCE_LIST_REQUEST,
    getDailyCostResourceListRequest,
  );

  yield takeLatest(DELETE_DAILY_COST_REQUEST, deleteDailyCostRequest);
}

export default costTrackingWatcher;
